module.exports = __webpack_public_path__ + "img/web_app_interface.a7b8385c.png";